/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.conf.js > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/



import '@quasar/extras/mdi-v4/mdi-v4.css'

import '@quasar/extras/roboto-font/roboto-font.css'



import '@quasar/extras/animate/slideInUp.css'

import '@quasar/extras/animate/slideOutDown.css'

import '@quasar/extras/animate/slideInDown.css'

import '@quasar/extras/animate/fadeIn.css'

import '@quasar/extras/animate/fadeOut.css'

import '@quasar/extras/animate/slideOutRight.css'

import '@quasar/extras/animate/zoomInLeft.css'

import '@quasar/extras/animate/zoomIn.css'

import '@quasar/extras/animate/zoomOut.css'

import '@quasar/extras/animate/lightSpeedInLeft.css'

import '@quasar/extras/animate/lightSpeedInRight.css'


// We load Quasar stylesheet file
import 'quasar/dist/quasar.sass'




import 'src/css/1-safe-area.scss'

import 'src/css/2-app.scss'

import 'src/css/3-custom-dialog.scss'

import 'src/css/4-introjs.scss'

import 'src/css/5-teacher-embed.scss'


import Vue from 'vue'
import createApp from './app.js'


import 'app/src-pwa/register-service-worker.js'




import qboot_Booti18n from 'boot/i18n'

import qboot_Bootaxios from 'boot/axios'

import qboot_Boottone from 'boot/tone'

import qboot_Bootanime from 'boot/anime'

import qboot_Bootvirtualscroller from 'boot/virtualscroller'

import qboot_Bootanalytics from 'boot/analytics'

import qboot_Bootrouterauth from 'boot/routerauth'

import qboot_Bootfilters from 'boot/filters'

import qboot_Bootcapacitor from 'boot/capacitor'

import qboot_Bootfirebase from 'boot/firebase'

import qboot_Bootmonitoring from 'boot/monitoring'











// Needed only for iOS PWAs
if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream && window.navigator.standalone) {
  import(/* webpackChunkName: "fastclick"  */ '@quasar/fastclick')
}


const publicPath = ``


async function start () {
  const { app, store, router } = await createApp()

  

  
  let hasRedirected = false
  const redirect = url => {
    hasRedirected = true
    const normalized = Object(url) === url
      ? router.resolve(url).route.fullPath
      : url

    window.location.href = normalized
  }

  const urlPath = window.location.href.replace(window.location.origin, '')
  const bootFiles = [qboot_Booti18n,qboot_Bootaxios,qboot_Boottone,qboot_Bootanime,qboot_Bootvirtualscroller,qboot_Bootanalytics,qboot_Bootrouterauth,qboot_Bootfilters,qboot_Bootcapacitor,qboot_Bootfirebase,qboot_Bootmonitoring]

  for (let i = 0; hasRedirected === false && i < bootFiles.length; i++) {
    if (typeof bootFiles[i] !== 'function') {
      continue
    }

    try {
      await bootFiles[i]({
        app,
        router,
        store,
        Vue,
        ssrContext: null,
        redirect,
        urlPath,
        publicPath
      })
    }
    catch (err) {
      if (err && err.url) {
        window.location.href = err.url
        return
      }

      console.error('[Quasar] boot error:', err)
      return
    }
  }

  if (hasRedirected === true) {
    return
  }
  

  

    

    

    
      new Vue(app)
    

    

    

  

}

start()
